import OrdemServicoAgendamentoService from "@/services/OrdemServicoAgendamentoService";

export const ordemServicoAgendamento = {
  namespaced: true,
  state: {},
  actions: {
    getCalendario({ commit }, payload) {
      return OrdemServicoAgendamentoService.GetCalendario(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getOrdemServicoAgendamento({ commit }, payload) {
      return OrdemServicoAgendamentoService.GetOrdemServicoAgendamento(
        payload
      ).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    getHistoricoCliente({ commit }, payload) {
      return OrdemServicoAgendamentoService.GetHistoricoCliente(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
    putReagendar({ commit }, payload) {
      return OrdemServicoAgendamentoService.PutReagendar(payload).then(
        (response) => Promise.resolve(response),
        (error) => Promise.reject(error.response?.data || error)
      );
    },
  },
  mutations: {},
};

export default ordemServicoAgendamento;
